module.exports = __webpack_public_path__ + "static/media/green-tick.d5cd4103.png";